export interface RuntimeConfig {
  API_URL?: string;
  API_BASE_URL?: string;
  WS_URL?: string;
  COGNITO_USER_POOL_ID?: string;
  COGNITO_CLIENT_ID?: string;
  COGNITO_REGION?: string;
  AUTH_SERVICE_URI?: string;
  COGNITO_ENDPOINT?: string;
  SENTRY_ENVIRONMENT?: string;
  SENTRY_DSN?: string;
}

export const runtimeConfig =
  (window as unknown as Record<'runtimeConfig', RuntimeConfig>).runtimeConfig ||
  {};

export default runtimeConfig;
